import { Component } from '@angular/core';
import { ResponseGetUsuarioAcessoDto } from '@app/data/usuario/models';
import { UsuarioRepository } from '@app/data/usuario/usuario.repository';
import { AuthService } from '@app/infra/auth/auth.service';
import { NavService } from '@app/infra/nav/nav.service';
import { ClientChangeController } from '@app/modules/auth/controllers/client-change.controller';
import { map, of } from 'rxjs';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent  {
  isShrinked = true;

  clientesUsuario!: Observable<any>;
  clienteDefault!: number;
  
  constructor(
    public authService: AuthService,
    public clientChangeController: ClientChangeController,
    private usuarioRepository: UsuarioRepository,
    public navService: NavService,
  ) {
    this.getUsuariosAcessos();
  }

  // carrega os clientes que o usuario logado tem acesso
  getUsuariosAcessos() {
    this.usuarioRepository.getUsuariosAcessos().subscribe((retorno: any) => {
      const result: any = retorno?.data;
      if (result) {
        const clienteSalvo = localStorage.getItem('clienteSelecionado');
        const clientesVinculados: Array<any> = [];

        const acessos = Array.isArray(result) ? result : (result?.acessos || []);

        acessos?.map((resultadoSubModulo: any, index: number) => {
          const clienteId =
            resultadoSubModulo?.grupoEconomico?.clienteAcessado?.id ??
            resultadoSubModulo?.codigoClienteAcessado;
          const razaoSocial =
            resultadoSubModulo?.grupoEconomico?.clienteAcessado?.pessoa?.razaoSocial ??
            resultadoSubModulo?.razaoSocialClienteAcessado;
          const nomeFantasia =
            resultadoSubModulo?.grupoEconomico?.clienteAcessado?.pessoa?.nomeFantasia ??
            resultadoSubModulo?.nomeFantasiaClienteAcessado;

          clientesVinculados.push({
            id: (clientesVinculados.at(-1)?.id || 0) + 1,
            clienteId,
            razaoSocial,
            nomeFantasia
          })
          const total = acessos?.length || 0;
          if ((total - 1) === index) {
            clientesVinculados.push({
              id: (clientesVinculados.at(-1)?.id || 0) + 1,
              clienteId: clientesVinculados.map((cliente: any) => cliente.clienteId),
              razaoSocial: "Todos Clientes",
              nomeFantasia: undefined
            })
          }
        })
        this.clientesUsuario = of(clientesVinculados);

        const firstId = clientesVinculados[0]?.id ?? 1;
        this.clienteDefault = clienteSalvo ? Number(clienteSalvo) : firstId;

        if (!clienteSalvo && clientesVinculados.length > 0) {
          this.setClienteDefault(this.clienteDefault);
        }
      }
    })
  }

  // seta o cliente default que o usuario selecionou
  setClienteDefault(codigoCliente: any) {
    this.clientesUsuario?.pipe(
      map(clientes => clientes.find((cliente: any) => cliente.id === codigoCliente))
    ).subscribe(clienteSelecionado => {
      this.clientChangeController.clientChange({
        multipleAcessClient: Array.isArray(clienteSelecionado.clienteId) ? clienteSelecionado.clienteId : [clienteSelecionado.clienteId]
      }).subscribe((retorno: any) => {
        if (retorno) {
          localStorage.setItem('clienteSelecionado', clienteSelecionado.id)
          localStorage.setItem('idClienteSelecionado', clienteSelecionado.clienteId)
          location.reload();
        }
      });
    });
  }

  getClienteById(id?: number) {
    return this.clientesUsuario?.pipe(
      map(clientes => {
        const targetId = id ?? this.clienteDefault;
        const cliente = clientes.find((c: any) => c.id === targetId);
        return cliente?.razaoSocial ?? '';
      })
    );
  }
}
